import React from 'react';
import ReactDOM from 'react-dom/client';
import type { EventPageType } from '../../services/Event/Event.repository';
import { PageBuilder } from './PageBuilder';

function Index({
  type = 'editor_d_offer',
}: {
  type?: EventPageType;
}): React.ReactElement {
  return (
    <React.StrictMode>
      <PageBuilder type={type} />
    </React.StrictMode>
  );
}

export default Index;
